import BlockContent from "../../block-content";
import { Script } from "gatsby";

import styled from "styled-components";
import tw from "twin.macro";
import { useState } from "react";
import MiniMasonry from "minimasonry";

const Intro = styled.div`
  p {
    ${tw`text-sm md:text-lg mb-8`}
  }
`;
const Form = styled.div`
  .submitted-message p {
    ${tw`font-bold md:text-lg bg-white text-blue-500 px-4 py-1 my-6`}
  }
  .hs-form-field {
    ${tw`w-full px-2 mb-1`}
    .hs-error-msg {
      ${tw`px-2 py-1 tracking-tight text-xs bg-red-500 text-white mb-6 inline-block`}
    }
    label {
      ${tw`font-bold text-sm`}
    }
    select.hs-input {
      ${tw`rounded`}
      display: block;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 1.75rem 0.375rem 0.75rem;
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      border: 1px solid #ced4da;
    }
  }
  .hs-form-private {
    ${tw`flex flex-wrap -mx-2`}
    @media (max-width: 520px) {
      display: block;
    }
  }
  .hs_error_rollup {
    display: none;
  }
  .input {
    margin-right: 0 !important;
  }
  input {
    width: 100% !important;
    ${tw`block rounded px-2 py-1 h-10 w-full mb-2 text-gray-900`}
    &[type='submit'] {
      cursor: pointer;
      ${tw`mx-2 text-sm text-center md:text-base px-4 md:px-6 mt-6 py-2 h-auto rounded transition ease-in-out duration-200 text-yellow-900 bg-yellow-500 shadow-lg uppercase tracking-tight items-center font-bold hover:bg-blue-600 hover:text-white`}
     @media (max-width: 520px) {
        margin: 0 !important;
      }
    }
  }
  .hs-submit {
    @media (max-width: 520px) {
      padding: 8px;
    }
  }
`;

export default function HubSpotFormBlock({ props }) {
  const hubSpotFormBlock = props.hubSpotFormBlock;

  const [loaded, setLoaded] = useState(false);
  return (
    <section className="bg-blue-500 text-white py-8 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-yellow-500 leading-tight font-bold tracking-tighter text-2xl md:text-3xl mb-2">
          {" "}
          {hubSpotFormBlock.title}
        </h2>
        <Intro>
          <BlockContent blocks={hubSpotFormBlock._rawDescription} />
        </Intro>
        <Form id={`interest-form`} />
        <Script>
          {`
          function loadHubSpotForm() { 
            hbspt.forms.create({portalId: "${hubSpotFormBlock.portalId}",
                    formId: "${hubSpotFormBlock.formId}" ,
                    target: "#interest-form"})
          }
        setTimeout(loadHubSpotForm, 1500);
        `}
        </Script>
      </div>
    </section>
  );
}
